import { render } from "./IntegerGenderField.vue?vue&type=template&id=3dd60917&ts=true"
import script from "./IntegerGenderField.vue?vue&type=script&lang=ts"
export * from "./IntegerGenderField.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__